import { PATHS } from '@utils/paths';

export const LEGACY_REDIRECTS = [
  { from: PATHS.LEGACY.claimFiles, to: PATHS.PRIVATE_BASE.claimFiles },
  {
    from: PATHS.LEGACY.scheduledReports,
    to: PATHS.PRIVATE_BASE.scheduledReports,
  },
  {
    from: PATHS.LEGACY.claimscoreSettings,
    to: PATHS.PRIVATE_BASE.claimscoreSettings,
  },
];
